import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Nav } from './components/site/Nav';
import { Footer } from './components/site/Footer';
import { Home } from './pages/Home';
import { Methodology } from './pages/Methodology';
import { Company } from './pages/Company';
import { DemoRedirect } from './pages/DemoRedirect';
import { applyDocumentMetadata } from './utils/metadata';

/** Routed pages should open at the top, not at the previous scroll position. */
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    applyDocumentMetadata();
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2wiyxuugtfxcq">
      <div className="w-full bg-bone font-sans text-ink" data-id="element-1" data-mp="2wiffjcn976y6">
        <ScrollToTop data-id="element-2" data-mp="28tw5osok2m3z" />
        <Nav data-id="element-3" data-mp="28te3lff7pdo5" />
        <main data-id="element-4" data-mp="28sutulzptvl7">
          <Routes data-id="element-5" data-mp="28sl0cofgp6ar">
            <Route path="/" element={<Home data-id="element-7" data-mp="23vuq4hqc94x9" />} data-id="element-6" data-mp="23vciyq2516ak" />
            <Route path="/methodology" element={<Methodology data-id="element-9" data-mp="23t8gmcjw0fce" />} data-id="element-8" data-mp="23ujksdh8vp41" />
            <Route path="/company" element={<Company data-id="element-11" data-mp="3ij652c0mxp8x" />} data-id="element-10" data-mp="3ik7k0rkruvvx" />
            <Route path="/demo" element={<DemoRedirect data-id="element-13" data-mp="3mlj8uuvtnd32" />} data-id="element-12" data-mp="3ijpet5g4t7bv" />
            <Route path="/demo/" element={<DemoRedirect data-id="element-15" data-mp="3mjq1fdddwou0" />} data-id="element-14" data-mp="3mkhlps1j704z" />
          </Routes>
        </main>
        <Footer data-id="element-16" data-mp="3rbzo8kj7d8s2" />
      </div>
    </BrowserRouter>;
}